import { useEffect } from "react";
import Received from '../table/Tablereceive';
import Modal from "../modal/Modalreceive"
import Modaldispatch from "../modal/Modaldispatch"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
   <Modal/>
 
    <Received/>
    
     </>
  );
};

export default Dashboard;
